import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SearchPanel from '@components/SearchPanel/SearchPanel';
import Table from './Table/Table';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import { Helmet } from 'react-helmet';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import EscrowCompanyModal from './EscrowCompanyModal/EscrowCompanyModal';
import { withRouter } from 'react-router';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class EscrowCompanies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phraze: '',
      modalActive: false
    };

    if (props.list.length === 0) {
      props.getList({}, true);
    }
  }

  componentDidMount = () => {
    document.getElementsByClassName('input-search')[0].click();
    document.getElementsByClassName('input-search')[0].focus();
  };

  onEntityClick = entityId => {
    this.props.history.push(`/escrow-companies/${entityId}`);
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  searchTimeout: null;

  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });
    this.searchTimeout = setTimeout(
      () =>
        this.props.getList({
          phraze: value,
          limit: this.props.limit,
          sort: this.props.sort,
          direction: this.props.direction
        }),
      1000
    );
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Escrow Companies</title>
        </Helmet>
        <div className={this.props.loaded ? 'position-relative' : 'd-none'}>
          {this.props.loading && (
            <ProgressBox text={'Loading ...'} loader={'blue-background'} />
          )}
          <h3>Escrow Companies</h3>
          <SearchPanel
            showFilter={false}
            createBtn={false}
            searchValue={this.state.phraze}
            onSearchChange={phraze => this.onSearch(phraze)}
            searchPlaceholder={'Search by Escrow Company’s name'}
          >
            <Auth action={'EscrowCompanies::edit'}>
              <button
                className={'btn btn-primary px-3'}
                onClick={() => this.toggle('modalActive')}
              >
                Create New Escrow Company
              </button>
            </Auth>
          </SearchPanel>
          <Table
            entities={this.props.list}
            onEntityClick={entityId => this.onEntityClick(entityId)}
            {...this.props}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <PaginationPanel
            page={this.props.page}
            limit={this.props.limit}
            total={this.props.total}
            start={this.props.start}
            end={this.props.end}
            sort={this.props.sort}
            direction={this.props.direction}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <EscrowCompanyModal
            entity={{}}
            history={this.props.history}
            isActive={this.state.modalActive}
            toggle={() => this.toggle('modalActive')}
          />
        </div>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    list: state.escrowCompany.list,
    page: state.escrowCompany.page,
    limit: state.escrowCompany.limit,
    total: state.escrowCompany.total,
    start: state.escrowCompany.start,
    end: state.escrowCompany.end,
    sort: state.escrowCompany.sort,
    loaded: state.escrowCompany.loaded,
    direction: state.escrowCompany.direction,
    loading: state.escrowCompany.loading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getList: (getData, hideLoader) =>
      dispatch(actions.getEscrowCompaniesList(getData, hideLoader))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EscrowCompanies)
);
